/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

import { ColorSchemeToggle } from "components/ColorSchemeToggle/ColorSchemeToggle";
import Logo from "components/Header/Logo";
import useRouting from "hooks/useRouting";
import { useOrgData } from "state/OrgDataContext";
import { useUI } from "state/UIContext";
import TermsOfUseAndPolicyModal from "templates/TermsOfUseAndPolicyModal";
import { Button } from "..";

const Footer = ({ isScreenPage = false }) => {
  const { setColorScheme, colorScheme, openModal, closeModal } = useUI();
  const { logoRoute } = useRouting();
  const { dataContent: EVENT_CONTENT } = useOrgData();

  return (
    <footer className="flex flex-col space-y-8 py-5 px-4 md:py-11 md:px-[120px] w-full -bg--theme-colors-surface-neutral-level02">
      <div className="flex justify-between items-center -text--theme-colors-text-body">
        <Button
          as="link"
          variant="link"
          to={logoRoute}
          className="ps-0 min-h-[auto]"
        >
          {!isScreenPage && <Logo />}
        </Button>
        {!isScreenPage && (
          <ColorSchemeToggle
            colorScheme={colorScheme}
            setColorScheme={setColorScheme}
          />
        )}
      </div>

      <div className="flex sm:flex-row flex-col justify-between items-center  -text--theme-colors-text-body">
        {!isScreenPage && (
          <div className="flex gap-x-4 text-end">
            <Button
              variant="link"
              className="-text--theme-colors-text-body no-underline hover:underline font-normal sm:text-base text-sm min-h-[auto]"
              onClick={() =>
                openModal({
                  content: (
                    <TermsOfUseAndPolicyModal
                      type="policy"
                      closeModal={closeModal}
                    />
                  ),
                })
              }
            >
              {EVENT_CONTENT?.footer?.privacyPolicyMSG ?? ""}
            </Button>
            <Button
              variant="link"
              className="-text--theme-colors-text-body hover:underline  no-underline font-normal sm:text-base text-sm  min-h-[auto]"
              onClick={() =>
                openModal({
                  content: (
                    <TermsOfUseAndPolicyModal
                      type="terms"
                      closeModal={closeModal}
                    />
                  ),
                })
              }
            >
              {EVENT_CONTENT?.footer?.termsOfUseMSG ?? ""}
            </Button>
          </div>
        )}
        <p className="sm:text-start text-center">
          {EVENT_CONTENT?.footer?.copyrightMSG ?? ""}
        </p>
        {isScreenPage && (
          <ColorSchemeToggle
            colorScheme={colorScheme}
            setColorScheme={setColorScheme}
          />
        )}
      </div>
    </footer>
  );
};

export default Footer;
